import { lazy } from 'react';

// Components to preload
const LoadingOverlay = lazy(() => import('../components/LoadingOverlay'));

export const preloadComponents = () => {
  // Preload LoadingOverlay component
  const preloadLoadingOverlay = () => LoadingOverlay;
  preloadLoadingOverlay();
}; 